import styled from '@emotion/styled';
import { Color } from '@liveoptics/react-ui';

const TextButton = styled.a`
  color: ${Color.blueDell};
  font-size: 16px;
  padding-top: 15px;
  font-weight: 600;
  text-decoration: none;
  cursor: pointer;
  &:active {
    color: ${Color.blue300};
  }
`;

export default TextButton;
